// Registers the offline worker (app/views/pwa/_offline_worker.js.erb) where the
// server asks for it: the layout renders <meta name="service-worker"> only for
// an app that announces Outbox/1, while the offline_worker flag is on.
// Browsers never get the meta. Old app builds have no navigator.serviceWorker
// (WKWebView exposes it only with App-Bound Domains), so nothing runs there.
//
// With the flag off the same app gets <meta name="service-worker-retired">
// instead, and an installed worker is removed at once. Removal keys on that
// explicit meta, never on a missing one: a page from another layout or a
// stored copy must not take the worker down.
let registered = false
let retired = false

function register() {
  if (!("serviceWorker" in navigator)) return

  if (document.querySelector('meta[name="service-worker-retired"]')) {
    retire()
    return
  }

  const url = document.querySelector('meta[name="service-worker"]')?.content
  if (registered || !url) return

  registered = true
  // Registration does not store the page already on screen: once the worker
  // controls it, hand it the assets this page loaded plus the home.
  navigator.serviceWorker.addEventListener("controllerchange", warmUp, { once: true })
  navigator.serviceWorker.register(url, { scope: "/" }).catch((error) => {
    registered = false
    console.warn("Service worker registration failed", error)
  })
}

// Same caches as the retired worker script deletes; it covers devices that
// do not load a page first.
async function retire() {
  if (retired) return
  retired = true

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map((registration) => registration.unregister()))
    const names = await caches.keys()
    await Promise.all(names.filter((name) => name.startsWith("pages-") || name.startsWith("assets-")).map((name) => caches.delete(name)))
  } catch (error) {
    retired = false
    console.warn("Service worker removal failed", error)
  }
}

function warmUp() {
  const urls = performance.getEntriesByType("resource")
    .map((entry) => entry.name)
    .filter((name) => {
      const url = new URL(name, window.location.href)
      return url.origin === window.location.origin && url.pathname.startsWith("/assets/")
    })

  navigator.serviceWorker.controller?.postMessage({ type: "warm-up", urls: [ ...new Set(urls), "/" ] })
}

document.addEventListener("turbo:load", register)
